<script setup>
import MarkdownRenderer from '~/common/components/MarkdownRenderer.vue';

import ContributorSocialLinks from './ContributorSocialLinks.vue';

defineProps({
  release: {
    type: Object,
    required: true,
  },
});
</script>

<template>
  <div>
    <img
      v-for="contributor in release.contributors"
      :key="contributor.gitlabUsername"
      :src="`/users/${contributor.gitlabUsername}/banner.svg`"
      :alt="`${contributor.name} contributor banner`"
      class="w-100 mb-3"
    >
    <MarkdownRenderer
      v-if="release.writeUp"
      :markdown-content="release.writeUp"
      use-marked-renderer
    />
    <ContributorSocialLinks :contributors="release.contributors" />
  </div>
</template>
